import { isUndNullEmp } from '../../helpers/main';
import { Role } from '../role/role';
import { TokenUser } from '../token/tokenUser';
import { User } from '../user/user';

export class LoginResponse {
    constructor(
        _user = User?.getClass(),
        _token = TokenUser.class(),
        _role = Role?.class(),
    ) {
        this.user = _user;
        this.token = _token;
        this.role = _role;
    }

    static getClassName = () => {
        return 'LoginResponse - class';
    }

    static class = (obj = {}) => {
        if (!isUndNullEmp({ data: obj, subMethod: this.getClassName() })?.result) {
            return new LoginResponse(
                obj.user,
                obj.token,
                obj.role,
            );
        } else {
            return new LoginResponse();
        }
    }
}